import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SendPushMessageDto } from "@myapp/contract";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/**
 * Sends a broadcast to a list of users.
 *
 * Invalidates the whole notification key space: the send writes a history row, prunes
 * endpoints the push service reported gone (so device lists and stats can shrink), and the
 * admin user list nests those devices.
 */
export function useSendPushMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: SendPushMessageDto) =>
      notificationApi.sendMessage(dto).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}
